import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/diduimp/report/processos-ref';

// A resposta vem como blob, e um erro sem corpo (500 sem mensagem, 204) vira string vazia —
// que a tela leria como sucesso. Por isso toda falha sai daqui com mensagem preenchida.
const lerMensagemDeErro = async (data: any, status: number): Promise<string> => {
  let texto = '';

  try {
    if (data instanceof Blob) {
      texto = (await data.text()).trim();
    } else if (typeof data === 'string') {
      texto = data.trim();
    }
  } catch {
    texto = '';
  }

  if (texto) {
    return texto;
  }

  if (status === 204) {
    return 'Nenhum processo encontrado para os filtros informados.';
  }

  return `Erro ao gerar o relatório (HTTP ${status}).`;
};

const generateSpreadsheetProcessosRef = async (
  token: string,
  unidadeId: number,
  clienteId?: string,
  processos?: string[],
  dataInicio?: string,
  dataFim?: string
) => {
  const params = new URLSearchParams();
  if (clienteId) {
    params.set('cliente', clienteId);
  }
  if (processos && processos.length > 0) {
    params.set('processos', processos.join(','));
  }
  if (dataInicio) {
    params.set('inicio', dataInicio);
  }
  if (dataFim) {
    params.set('fim', dataFim);
  }

  let message = null;

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'resumoProcessosRegistrados.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      message = await lerMensagemDeErro(response.data, response.status);
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      message = await lerMensagemDeErro(error.response.data, error.response.status);
    } else {
      message = 'Erro inesperado ao gerar o relatório.';
    }
  }

  return message;
};

export { generateSpreadsheetProcessosRef };
